var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15V17H0V15H14ZM11 8.215C10.9671 8.87498 10.7711 9.51653 10.4297 10.0823C10.0883 10.6481 9.61207 11.1205 9.04352 11.4572C8.47497 11.794 7.83184 11.9847 7.17161 12.0122C6.51138 12.0397 5.85461 11.9033 5.26 11.615C4.57464 11.3185 3.99341 10.8241 3.59077 10.1952C3.18813 9.56633 2.98242 8.83154 3 8.085V0.00500011H1V8.215C1.03383 9.15641 1.28885 10.0766 1.74442 10.9012C2.19998 11.7257 2.84329 12.4314 3.62227 12.9611C4.40125 13.4908 5.294 13.8296 6.22827 13.9502C7.16254 14.0707 8.11207 13.9696 9 13.655C10.1811 13.2613 11.2059 12.5012 11.9252 11.485C12.6446 10.4689 13.0211 9.24981 13 8.005V0.00500011H11V8.215ZM11 0H13H11ZM3 0H1H3Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.ef3d679a3e4992ad4e87463dcd4fc323.svg";
export { ForwardRef as ReactComponent };